import { render, staticRenderFns } from "./PasswordSettings.vue?vue&type=template&id=4a508c5b&scoped=true&"
import script from "./PasswordSettings.vue?vue&type=script&lang=js&"
export * from "./PasswordSettings.vue?vue&type=script&lang=js&"
import style0 from "./PasswordSettings.vue?vue&type=style&index=0&id=4a508c5b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a508c5b",
  null
  
)

export default component.exports